import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const Meda = React.lazy(async () => ({
    default: (await import('@oc/meda/module')).MedaConfig
}))

export function MedaComponent() {
    return <SuspenseWhileLoading LazyComponent={Meda} />
}
